import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 0C4.455 0 0 4.455 0 10c0 5.546 4.455 10 10 10 5.546 0 10-4.454 10-10 0-5.545-4.454-10-10-10m0 18c-4.444 0-8-3.556-8-8s3.556-8 8-8c4.445 0 8 3.556 8 8s-3.556 8-8 8m4-9H6c-.6 0-1 .4-1 1s.4 1 1 1h8c.6 0 1-.4 1-1s-.4-1-1-1"
    }, null, -1)
  ]))]))
}
export default { render: render }